<div class="u-h-100">
    <div class="auth-loading-container">

        <div style="border: 1px solid black; border-radius: 0.25rem; padding: 1rem; background-color: white; text-align: center; max-width: 40rem; margin: 0 auto;">

            <!-- Reusing standard classes in your app based on login-failed -->            
            <h1 class="u-margin-b-4">Please wait...</h1>
            <p class="u-margin-b-5 u-text-muted" style="max-width: 40rem; text-justify: center; margin: 0 auto;">
                @if (hasAuthStateInHash()) {                    
                    Securing your session...
                }
                @else {
                    Loading
                }                
            </p>
            @if (isTakingLongerThanExpected())
            {
                <p class="small text-danger mt-3" style="margin-top: 2rem;">
                    This is taking a little longer than expected. Please hold tight...
                </p>
            }
        </div>
    </div>
</div>
